import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { PublicRoute } from './PublicRoute';
import { PrivateRoute } from './PrivateRoute';
import { Navbar } from '../components/UI/NavBar';
import { startCargaInicial } from '../state/actions/actions';

// ✅ Importación con Lazy Loading (para mejorar rendimiento)
const Home = lazy(() => import('../components/home'));
const Login = lazy(() => import('../components/auth/login'));
const Reportes = lazy(() => import('../components/reportes/ResumenCalificaciones'));
const Planificacion = lazy(() => import('../components/planificacion/Planificacion'));
const Calificaciones = lazy(() => import('../components/calificaciones/Calificaciones'));

export const AppRouter = () => {
  const dispatch = useDispatch();
    //const { autenticado, docente } = useSelector( state => state.auth );
    const { isAuthenticated, docente } = useSelector(state => state.auth);

   /* useEffect(() => {
        dispatch( VerificarAutenticado() );
    }, [ dispatch ])*/
    
    useEffect(() => {
        if ( isAuthenticated ) {
            dispatch( startCargaInicial( docente ) );
        }
    }, [isAuthenticated, dispatch, docente]);

  return (
    <BrowserRouter>
      {isAuthenticated && <Navbar />}
      <Suspense fallback={<div>Cargando...</div>}>
        <Routes>
          {/* 🔓 Rutas públicas */}
          <Route
            path="/login"
            element={
              <PublicRoute isAuthenticated={isAuthenticated}>
                <Login />
              </PublicRoute>
            }
          />

          {/* 🔒 Rutas privadas */}
          <Route
            path="/"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path="/calificaciones"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <Calificaciones />
              </PrivateRoute>
            }
          />
          <Route
            path="/planificacion"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <Planificacion />
              </PrivateRoute>
            }
          />
          <Route
            path="/reportes"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <Reportes />
              </PrivateRoute>
            }
          />

          {/* Redirección por defecto */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
